export default __webpack_public_path__ + "static/careers-benefits-block1-icon09.url-205dd8f564c5242af7ea53b8561ed9a1.svg";